import { SyncStatusIndicator } from '@all-manager/design-system-v2';
import { useSyncStatusBadge } from './useSyncStatusBadge';

type Props = {
  spaceId?: string;
};

export default function SyncStatusBadge(props: Props) {
  const { label, tooltip, status } = useSyncStatusBadge(props);

  return <SyncStatusIndicator status={status} label={label} tooltip={tooltip} />;
}
